import "../../../newComponents/listings/top-listing-headers/top-listing-headers.css";
import SearchFilterInput from "../../../newComponents/form-fields/search-filter-input";
import SimpleButton from "../../../newComponents/buttons/Simple-button";
import H2 from "../../../newComponents/typography/H2";
import SortIcon from "../../../assets/svgs/SortIcon";
import SingleDropdown from "../../../newComponents/singleDropdown/SingleDropdown";
import Chevren_downIcon from "../../../assets/svgs/Chevren_down";

interface ManageUsersTopHeaderProps {
  className?: string;
  PageHeading?: string;
  ButtonName?: string;
  MobileButtonName?: string;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  onClick?: () => void;
  handleFilterChange: (filter: string) => void;
  filterOptions?: { title: string; count: number }[];
  activeFilter: string;
  sortDirection: "asc" | "desc";
  onSortChange: (direction: "asc" | "desc") => void;
}

export default function ManageUsersTopHeader({
  className = "",
  PageHeading,
  ButtonName,
  MobileButtonName,
  searchTerm,
  setSearchTerm,
  onClick,
  handleFilterChange,
  filterOptions = [],
  activeFilter,
  sortDirection,
  onSortChange,
}: ManageUsersTopHeaderProps) {
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const activeOption = filterOptions.find((option) => option.title === activeFilter);

  return (
    <div className={`top-listing-header manage-users-header ${className}`}>
      <div className="top-listing-header-main">
        <div className="top-listing-header-left">
          <H2 text={PageHeading || ""} />
        </div>

        <div className="top-listing-header-right">
          <div className="manage-users-header-actions">
            <div className="filters-mobile">
              <SingleDropdown
                triggerText={`${activeFilter} (${activeOption?.count ?? 0})`}
                triggerIcon={<Chevren_downIcon width={"18"} height={"18"} />}
                triggerIconPosition="right"
                menuItems={filterOptions.map((option) => ({
                  label: `${option.title} (${option.count})`,
                  action: () => handleFilterChange(option.title),
                }))}
              />
            </div>
            <SearchFilterInput
              placeholder="Search by User Name"
              searchTerm={searchTerm}
              handleSearch={handleSearch}
            />
            <div className="search-sort-container">
              <div className="sort-button"
                onClick={() => onSortChange(sortDirection === "asc" ? "desc" : "asc")}>
                <span className="sort-text">
                  {sortDirection === "asc"
                    ? "Sort by: A-Z"
                    : "Sort by: Z-A"}
                </span>
                <SortIcon />
              </div>
            </div>

            {ButtonName && (
              <SimpleButton
                className="top-listing-header-button-desktop"
                label={ButtonName}
                onClick={onClick}
              />
            )}
            {(MobileButtonName || ButtonName) && (
              <SimpleButton
                className="top-listing-header-button-mobile"
                label={MobileButtonName || ButtonName}
                onClick={onClick}
              />
            )}
          </div>
        </div>
      </div>

      <div className="top-listing-header-filters top-listing-header-filters--pills">
        <div className="filter-options filters-desktop filter-options--pills">
          {filterOptions.map((option) => (
            <button
              key={option.title}
              className={`filter-option ${activeFilter === option.title ? "filter-option-active" : ""}`}
              onClick={() => handleFilterChange(option.title)}
            >
              {option.title} ({option.count})
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
